import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { CapicheLoggerService } from 'capiche-logger';

export type FontChoice = 'default' | 'openDyslexic' | 'courier';

@Injectable({
  providedIn: 'root',
})
export class FontPreferenceService {
  private logger = new CapicheLoggerService('font-preference.service', false);
  private readonly storageKey = 'capicheFontPreference';
  private readonly legacyKey = 'capicheDyslexiaMode';

  private fontSubject = new BehaviorSubject<FontChoice>(this.getInitialFont());
  selectedFont$ = this.fontSubject.asObservable();

  constructor() {
    this.logger.log('constructor');
  }

  private getInitialFont(): FontChoice {
    const stored = localStorage.getItem(this.storageKey);
    if (stored === 'openDyslexic' || stored === 'courier') return stored;
    // migrate legacy dyslexia toggle
    const legacy = localStorage.getItem(this.legacyKey);
    if (legacy === 'true') return 'openDyslexic';
    return 'default';
  }

  setFont(font: FontChoice) {
    this.logger.log('setFont', font);
    localStorage.setItem(this.storageKey, font);
    this.fontSubject.next(font);
  }

  getSelectedFont(): FontChoice {
    return this.fontSubject.getValue();
  }
}
